const { GameContainer } = require('./container/gameContainer');

export default GameContainer;